'use client';

import { c as _c } from "react/compiler-runtime";
import { CheckCircle2, MessagesSquare, Workflow } from 'lucide-react';
import type { JSX } from 'react';
import { cn } from '@/lib/utils';
import type { ReasoningTraceEntry } from './chat-types';
interface ReasoningTraceProperties {
  className?: string;
  entries: ReasoningTraceEntry[];
}
const ICONS: Record<ReasoningTraceEntry['type'], () => JSX.Element> = {
  'tool-call': () => <Workflow className="h-3.5 w-3.5 text-primary" aria-hidden="true" />,
  'tool-result': () => <CheckCircle2 className="h-3.5 w-3.5 text-success" aria-hidden="true" />,
  note: () => <MessagesSquare className="h-3.5 w-3.5 text-muted-foreground" aria-hidden="true" />
};
export function ReasoningTrace(t0) {
  const $ = _c(10);
  const {
    entries,
    className
  } = t0;
  if (!entries || entries.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== className) {
    t1 = cn("rounded-2xl border border-border/50 bg-muted/10 px-3 py-2 text-xs text-muted-foreground shadow-[018px_38px_-28px_rgba(15,23,42,0.4)] dark:border-border/60 dark:bg-muted/20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="mb-1 flex items-center gap-2 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground/90"><span className="inline-flex h-4 w-4 items-center justify-center rounded-full bg-primary/10 text-primary"><Workflow className="h-3 w-3" aria-hidden="true" /></span>Reasoning Trace</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== entries) {
    t3 = entries.map(_temp);
    $[3] = entries;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <ul className="space-y-1.5">{t3}</ul>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t4) {
    t5 = <div className={t1}>{t2}{t4}</div>;
    $[7] = t1;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp(entry) {
  return <li key={entry.id} className="flex items-start gap-2"><span className="mt-0.5 inline-flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-background text-foreground shadow-sm">{(ICONS[entry.type] ?? ICONS.note)()}</span><div className="min-w-0 flex-1"><div className="font-medium text-foreground/90">{entry.title}</div>{entry.detail ? <div className="text-muted-foreground/90">{entry.detail}</div> : null}</div></li>;
}